import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";

import HubHookFormSelect from "../HubHookFormSelect/HubHookFormSelect";
import { HubIcon } from "../HubIcon";

export const StyledHubHookFormSelect = styled(HubHookFormSelect)(
  ({ theme }) => ({
    "& .MuiInputBase-root ": {
      padding: "10px 15px !important",
      "& .MuiSvgIcon-root": {
        margin: "0px !important",
      },
      input: {
        backgroundColor: "transparent !important",
      },
    },
    "& .MuiSelect-select": {
      "& .MuiTypography-root": {
        fontWeight: 400,
        fontSize: "10px !important",
      },
    },
    "& .MuiChip-root": {
      display: "none",
    },
  })
);

export const StyledFormControl = styled(FormControl)(({ hidden }) => ({
  // zIndex: 1000000,
  overflow: "hidden",
  ...(hidden && {
    display: "none",
  }),
}));

export const StyledHubIcon = styled(HubIcon)(({ theme }) => ({
  color: `${theme.palette.hubColors.grey} !important`,
}));
